module.exports = __webpack_public_path__ + "media/images/portal_options-d608f82b.svg";